import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useSettingsDeepLink = (openSettings: () => void): void => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('settings') === 'mcpTokens') {
      openSettings();
      params.delete('settings');
      const search = params.toString();
      navigate(`${location.pathname}${search ? `?${search}` : ''}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);
};
